import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import AuthShell from "../components/AuthShell";
import { Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Set a new password"
      subtitle="Choose something you'll remember."
      footer={<Link to="/login" className="text-[#4da6ff] hover:underline">Back to sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        {error && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-lg px-4 py-2">{error}</div>}
        {!token && <div className="text-sm text-amber-400">Missing reset token in the link.</div>}
        <input data-testid="reset-password" type="password" required placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full field px-4 py-3" />
        <button type="submit" disabled={loading || !token} data-testid="reset-submit"
          className="w-full bg-[#4da6ff] hover:bg-[#7ab8ff] text-white font-medium rounded-full py-3 transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
          {loading && <Loader2 className="w-4 h-4 animate-spin" />} Update password
        </button>
      </form>
    </AuthShell>
  );
}
